import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from '../Modal/Modal';
import { useNavigate } from 'react-router-dom';
import { SelectInspectionTypeModalProps } from './types';
import MeetingsImg from '../../../assets/images/Meetings.png';
import { ReactComponent as CheckListIcon } from '../../../assets/images/square_checklist.svg';
import './SelectInspectionTypeModal.scss';
import { useTranslation } from 'react-i18next';

export const SelectInspectionTypeModal: React.FC<
  SelectInspectionTypeModalProps
> = ({ open, projectId, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handlePickScheduleClick = () => {
    navigate(`/project/${projectId}/scheduled-inspections`);
    onClose();
  };

  const handleStartNewClick = () => {
    navigate(`/project/${projectId}/conduct-inspection`);
    onClose();
  };

  return (
    <Modal
      show={open}
      modalClassName="select-inspection-type-modal"
      title="Choose From Below"
      submitBtnText=""
      cancelBtnText=""
      type="success"
      footerContentAlignment="right"
      onClose={onClose}
      onSubmit={() => {}}
    >
      <div className="d-flex action-container">
        <div className="action">
          <img alt="" src={MeetingsImg} />
          <Button onClick={handlePickScheduleClick}>
            {t('btn_pick_from_schedule')}
          </Button>
        </div>
        <span className="divider" />
        <div className="action">
          <CheckListIcon />
          <Button onClick={handleStartNewClick}>{t('btn_start_new')}</Button>
        </div>
      </div>
    </Modal>
  );
};
